<template>
<div class="modal-wrapper">
    <b-modal
        v-model="active"
        @hidden="hiddenModal"
        :size="modalSize"
        :class="modalClass"
    >
        <OrderReferenceView
            v-if="modal.modal === ProductionControlModals.ORDER_REFERENCE_VIEW"
            :fromModal="true"
        />
        <AlarmModal
            v-if="modal.modal === ProductionControlModals.ALARMS"
            :alarm="modal.data"
        ></AlarmModal>
    </b-modal>
</div>
</template>

<script>

import OrderReferenceView from "../../order_reference_view/views/OrderReferenceView";
import {ProductionControlModals} from "../utils";
import {mapActions, mapGetters} from "vuex";
import AlarmModal from "./AlarmModal";
export default {
    name: "Modal",
    props:{
        modal: Object
    },
    components: {
        AlarmModal,
        OrderReferenceView
    },
    data(){
        return {
            ProductionControlModals: ProductionControlModals,
            active: true
        }
    },
    computed:{
        ...mapGetters('production_control', ['activeModalByModalName','activeModals']),
        modalSize(){
            let modalSize = 'sm';
            switch(this.modal.modal){
                case ProductionControlModals.ORDER_REFERENCE_VIEW: modalSize = 'xxl';  break;
            }
            return modalSize;
        },
        modalClass(){
            let modalClass = '';
            switch(this.modalSize){
                case 'xxl': modalClass = 'really-big-modal'; break;
            }
            return modalClass;
        }
    },
    mounted() {},
    methods:{
        ...mapActions('production_control', ['deleteActiveModal','changeActiveModalState']),
        hiddenModal(){
            this.deleteActiveModal(this.modal)
        }
    }

}
</script>